import { dispatchValidationErrors } from '../trigger/errorDispatcher.mjs';
import parseGA4Trigger from '../trigger/parseGA4Trigger.mjs';
import validateGA4Trigger from '../trigger/validateGA4Trigger.mjs';
import createGA4Event from './createGA4Event.mjs';
import { getContextErrors } from './eventContext.mjs';
import { getPlatformErrors } from './platform.mjs';
export default function ({ trigger, config }) {
    trigger = parseGA4Trigger(trigger, config);
    const errors = [
        ...getContextErrors(),
        ...getPlatformErrors(),
        ...validateGA4Trigger(trigger, config),
    ];
    const event = createGA4Event(trigger, config);
    event.params.valid = errors.length === 0;
    if (errors.length > 0) {
        dispatchValidationErrors(trigger, event, errors);
    }
    return event;
}
